import React from 'react';
import { MDBCol, MDBRow } from 'mdbreact';
import { PropTypes } from 'prop-types';

import Breadcrumb from 'components/Breadcrumb';
import DescriptionText from 'components/DescriptionText';
import FeaturedText from 'components/FeaturedText';
import Footer from 'components/Footer';
import ReturnPreviousPage from 'components/ReturnPreviousPage';

import { isType } from 'utils/core';

import * as S from './styles';

function Page({ children, title, subtitle, links, previousPage, pageAction }) {
  return (
    <>
      <S.Container>
        <S.BreadcrumbWrapper>
          {previousPage && (
            <ReturnPreviousPage
              text="voltar para a página anterior"
              returnTo={previousPage}
              handleClick={pageAction}
            />
          )}
          <MDBRow>
            <MDBCol sm="12">
              {!!links.length && <Breadcrumb paths={links} />}
            </MDBCol>
          </MDBRow>
        </S.BreadcrumbWrapper>
        <S.TitleContainer>
          {isType(title, 'string') ? <DescriptionText text={title} /> : title()}
          <FeaturedText text={subtitle} />
        </S.TitleContainer>
        <MDBRow>
          <MDBCol sm="12">{children}</MDBCol>
        </MDBRow>
      </S.Container>
      <Footer />
    </>
  );
}

Page.defaultProps = {
  title: 'Título',
  subtitle: 'Subtítulo',
  links: [],
};

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      textPath: PropTypes,
      pathTo: PropTypes.string.isRequired,
    }),
  ),
};

export default Page;
